import styled from 'styled-components/macro';
import { Row, Col, Button, Layout } from 'antd';
import { Link } from 'react-router-dom';

export const StyleMenu = styled(Button)`
    margin: 0;
    line-height: 1;
    color: #000;
`;

export const StyledRow = styled(Row)`
    flex-flow: nowrap;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    margin-right: 2em;
`;

export const StyledLocale = styled.span`
    color: #000;
    justify-content: flex-end;

    @media (max-width: 400px) {
        > .gx-language {
            display: none;
        }
    }

    > span {
        margin-left: 5px;
    }
`;

export const StyledButton = styled(Button)`
    line-height: 40px;
    margin: 0 0 0 8px;
    position: relative;
`;

export const StyledHeader = styled(Layout.Header)`
    height: 72px !important;
`;

export const StyledSide = styled(Col)`
    display: flex;
    align-items: inherit;
    justify-content: flex-end;

    @media(max-width: 990px) {
        margin-right: 1.5em;
    }
`;

export const StyledRowSide = styled(Row)`
    .favourites-orders, .favourites-quotes {
        width: 25%;
        max-width: 65px;
    }

    .locales {
        width: 50%;
        max-width: 150px;

        @media(max-width: 990px) {
            width: 40%;
        }
    }

    .icon-search {
        display: none;

        @media(max-width: 990px) {
            display: block;
            width: 10%;
        }
    }
`;

export const StyledLogo = styled(Link)`
    display: inline-block;
    width: 120px;
    vertical-align: middle;

    @media (max-width: 400px) {
        width: 90px;
    }

    > img {
        width: 100%;
        display: block;
    }
`;

export const StyledSearchs = styled(Col)`
    @media (max-width: 991px) {
        display: none !important;
    }
`;

export const StyledDiv = styled(Col)`
    @media (max-width: 991px) {
        display: block !important;
    }
`;

export const StyledFavorites = styled.div`
    display: flex;
    text-align: center;
    cursor: pointer;
    
    .la-star {
        color: #111;
        position: absolute;
        right: -2px;
        bottom: -2px;
    }

    .favicon {
        color: #ffc109;
    }
`;
